import React from 'react';
import './style.css';

export default function NotFoundViewport({ children }) {

  return (
    <section className="relative flex min-h-screen flex-col items-center justify-center bg-slate-950 overflow-hidden px-4">
      <div className="absolute top-0 -left-10 animate-blob-1 pointer-events-none">
        <div className="w-96 h-96 bg-blue-600 rounded-full mix-blend-screen filter blur-[128px] opacity-40"></div>
      </div>

      <div className="absolute bottom-0 right-0 animate-blob-2 pointer-events-none">
        <div className="w-[30rem] h-[30rem] bg-indigo-600 rounded-full mix-blend-screen filter blur-[128px] opacity-40"></div>
      </div>

      <div className="absolute top-1/2 left-1/2 animate-blob-3 pointer-events-none">
        <div className="w-[40rem] h-[40rem] bg-cyan-700 rounded-full mix-blend-screen filter blur-[150px] opacity-30 transform -translate-x-1/2 -translate-y-1/2"></div>
      </div>

      <div className="relative z-10 w-full max-w-2xl">
        <div className="flex justify-center mb-10">
          <img
            className="h-14 w-auto"
            src="/public/assets/logo-harpiAI.svg"
            alt="HarpiAI Logo"
          />
        </div>

        <div className="p-8 md:p-14">
          {children}
        </div>
      </div>
    </section>
  );
}
